module.exports = __webpack_public_path__ + "static/media/facebook.0891ed2a.svg";